const items = ["Instant delivery", "Pay with BTC", "ETH", "USDT", "LTC", "Gift cards", "Software keys", "Subscriptions"];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div data-testid="ticker-marquee" className="relative overflow-hidden border-y border-white/[0.06] py-5">
      <div className="marquee-track flex w-max gap-10">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10 font-display text-2xl font-medium uppercase tracking-tight text-zinc-400 sm:text-3xl">
            {t}
            <span className="h-2 w-2 rounded-full bg-violet-500" />
          </span>
        ))}
      </div>
    </div>
  );
};
